import React, { useState } from 'react';
import { FaTimes, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const Gallery: React.FC = () => {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  const galleryImages = [
    {
      src: '/images/banners/ban1.jpg',
      title: 'IT Solutions',
      category: 'Services'
    },
    {
      src: '/images/banners/connector.jpg',
      title: 'Electric Cloud',
      category: 'Cloud'
    },
    {
      src: '/images/banners/ban2.jpg',
      title: 'Web Implementation',
      category: 'Development'
    },
    {
      src: '/images/banners/ban3.jpg',
      title: 'Digital Transformation',
      category: 'Technology'
    },
    {
      src: '/images/banners/ban4.png',
      title: 'Networking Solutions',
      category: 'Infrastructure'
    },
    {
      src: '/images/banners/2.jpg',
      title: 'Enterprise Solutions',
      category: 'Business'
    },
  ];

  const openLightbox = (index: number) => {
    setSelectedImage(index);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const nextImage = () => {
    if (selectedImage !== null) {
      setSelectedImage((selectedImage + 1) % galleryImages.length);
    }
  };

  const prevImage = () => {
    if (selectedImage !== null) {
      setSelectedImage((selectedImage - 1 + galleryImages.length) % galleryImages.length);
    }
  };

  return (
    <section id="gallery" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="text-blue-600 font-semibold text-lg">Our Work</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mt-2 mb-4">
            Photo Gallery
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            Take a glimpse into our work environment, team activities, and successful project implementations.
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-xl cursor-pointer aspect-square"
              onClick={() => openLightbox(index)}
            >
              <img
                src={image.src}
                alt={image.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 text-white">
                  <p className="text-xs text-blue-300 mb-1">{image.category}</p>
                  <h3 className="font-semibold">{image.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Lightbox */}
        {selectedImage !== null && (
          <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4">
            <button
              onClick={closeLightbox}
              className="absolute top-4 right-4 text-white hover:text-orange-400 transition-colors"
            >
              <FaTimes size={30} />
            </button>

            <button
              onClick={prevImage}
              className="absolute left-4 text-white hover:text-orange-400 transition-colors"
            >
              <FaChevronLeft size={40} />
            </button>

            <div className="max-w-4xl max-h-[80vh]">
              <img
                src={galleryImages[selectedImage].src}
                alt={galleryImages[selectedImage].title}
                className="max-w-full max-h-[80vh] object-contain rounded-lg"
              />
              <div className="text-center mt-4 text-white">
                <p className="text-sm text-blue-300">{galleryImages[selectedImage].category}</p>
                <h3 className="text-xl font-semibold">{galleryImages[selectedImage].title}</h3>
                <p className="text-sm text-gray-400 mt-2">
                  {selectedImage + 1} / {galleryImages.length}
                </p>
              </div>
            </div>

            <button
              onClick={nextImage}
              className="absolute right-4 text-white hover:text-orange-400 transition-colors"
            >
              <FaChevronRight size={40} />
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;
